<template>
    <div class="main-content">

        <div class="card-group">
            <card title="成果简介" url="/achievement_introduce">
                <div class="text">
                    <p>民族服饰产业是我国边疆地区富有特色的民族经济产业，是中华优秀传统文化创造性转化和创新性发展的重要依托产业，急需具有家国情怀、创新实践能力和工匠精神的民族服饰创新设计人才。</p>
					<p>本成果坚持立德树人根本任务，深入落实全国教育大会精神和新文科育人理念，依托教育部新文科研究与改革实践项目，紧密联系区域经济发展，面向服务于内蒙古及我国边疆其他地区民族服饰产业的人才需求，以应用型人才培养为突破口，以提升学生实践、创新、服务和持续发展能力为目标，践行产出导向明确、与时俱进、持续改进的应用型人才培养模式改革创新，成效显著，服装与服饰设计专业入选国家级“一流本科专业”建设点。</p>
                </div>
            </card>
            <card title="成果创新点" url="/achievement_innovate">
                <div class="text">
                    <p>模式创新：构建起“学研产创一体，政校企融通”的“三四四”人才培养模式。</p>
				    <p>模式凸显了政府在政策引导和创新平台搭建中的作用，以及校企在合作过程中的主体地位，推动人才培养传统模式向“学研产创”一体化新模式转变。从2005年“草原季节”研创产品设计项目引入“产学研”理念，到2018年“布丝瑰行动计划”民族服饰设计研学基地项目建设，逐步建立起校企新型合伙人模式，完成“学研产创一体，政校企融通”的“三联合、四共建、四对接”的应用型人才培养“三四四”模式的转变。</p>
                </div>
            </card>
            <card title="成果视频" url="/videoView?path=files/demo.mp4">
                <div class="videobox">
                    <video autoplay loop muted controls width="340">
                        <source src="files/demo.mp4" type="video/mp4">
                    </video>
                </div>
            </card>
        </div>

        <div class="slideshow" id ="slideshow"  @mouseup="test">
			<div class="img move" v-for="(item,index) in imgs" :key="index" :style="{left: 160*index+'px'}">
				<img class="t" :src="item" @click="imgClick(item)"/>
			</div>
		</div>

        <!-- <button @click="Test()">test</button> -->
        <!-- <img src="../../assets/img/host_bj.png"/> -->

        <!-- https://sjxy.imac.edu.cn/html-sjxy/cgsb/index/files/application_form.pdf
        html-sjxy/cgsb/index/
        https://sjxy.imac.edu.cn/files/application_form.pdf -->

    </div>
</template>

<script>
import card from "../home_card.vue"
export default {
    components:{
        card
    },
    data(){
        return{
            imgs:[
					"dp/home-slide/img_01.jpg",
                    "dp/home-slide/img_02.jpg",
                    "dp/home-slide/img_03.jpg",
                    "dp/home-slide/img_04.jpg",
                    "dp/home-slide/img_05.jpg",
                    "dp/home-slide/img_06.jpg",
                    "dp/home-slide/img_07.jpg",
                    "dp/home-slide/img_08.jpg",
                    "dp/home-slide/img_09.jpg",
                    "dp/home-slide/img_10.jpg",
                    "dp/home-slide/img_11.jpg",
                    "dp/home-slide/img_12.jpg",
                    "dp/home-slide/img_13.jpg",
                    "dp/home-slide/img_14.jpg",
                    "dp/home-slide/img_15.jpg",
                    "dp/home-slide/img_16.jpg",
                    "dp/home-slide/img_17.jpg",
                    "dp/home-slide/img_18.jpg",
                    "dp/home-slide/img_19.jpg",
                    "dp/home-slide/img_20.jpg",
                    "dp/home-slide/img_21.jpg",
                    "dp/home-slide/img_22.jpg",
                    "dp/home-slide/img_23.jpg",
                    "dp/home-slide/img_24.jpg",
                    "dp/home-slide/img_25.jpg",
                    "dp/home-slide/img_26.jpg",
                    "dp/home-slide/img_27.jpg",
                    "dp/home-slide/img_28.jpg",
                    "dp/home-slide/img_29.jpg",
                    "dp/home-slide/img_30.jpg",
                    "dp/home-slide/img_31.jpg",
                    "dp/home-slide/img_32.jpg",
                    "dp/home-slide/img_33.jpg",
				]
        }
    },
    methods:{
        imgClick(item){
            console.log(item);
            let routeUrl = this.$router.resolve({
                path: '/imageView',
                query:{path:item}
            })
            // let routeUrl =  this.$router.resolve({name:'/imageView',params: {path:item}})
            window.open(routeUrl.href, '_blank')
        }
    },
    mounted(){
        var isok = true; //这里必须是局部变量，否则dom元素的事件，无法控制
        var slideshow = document.querySelector(".slideshow");
        slideshow.onmouseover = function(){
            isok = false;
        }
        slideshow.onmouseout =  function(){
            isok = true;
        }
        
        var moves =document.querySelectorAll(".move")	
        var imgs =[];
        for (let key in moves) {
            if(typeof(moves[key]) == "object"){
                imgs.push(moves[key]);

            }
        }
        
        this.timer = setInterval(() => {
            if(!isok)
                return;
            for (let key in imgs) {
                let img = imgs[key];
                // 1移动
                let value = imgs[key].style.left;
                value = value.slice(0, -2)
                value = value-1;
                
                //2 检查是否移除边界
                if(value<-160){
                    img.setAttribute('style', 'left: '+5120+'px'); // =>160*8 => 160*(图片个数-1)
                }else{
                    img.setAttribute('style', 'left: '+value+'px');
                }
            }
        }, 50);
    },
    created() {
		
    }
}
</script>

<style lang="scss" scoped>



.main-content{
    width: 100%;
    height: 100%;
    display:  flex;
    flex-direction: column;
    align-items: center;

    background-color: #d4f2ff;
    //background-image:url('../../../public/img/host_bj2.png');
    background-image:url('host_bj2.png');
    background-repeat:no-repeat;
    background-size: 100% ;

    .card-group{
        margin-top: 60px;
        margin-bottom: 60px;
        width: 1200px;
        height: 400px;
        display: flex;
        justify-content: space-between;

        .text{
            margin: 0px 20px;
            text-align: left;
            color: #666;
            font-size: 1.6ch;
            text-indent:30px;
            line-height: 3.6ch;

            overflow: hidden;

            text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 11;
			-webkit-box-orient: vertical;
            p{
                margin: 4px 0;
            }
        }

        .videobox{
            width: 340px;
            height: 300px;
            background-color: #111;
            margin: 20px 20px;
            box-sizing:border-box;
            video{
                margin-top: 60px;
            }
        }
    }


    .slideshow{
        width: 1200px;
        height: 185px;
        margin-top: 10px;
        margin-bottom: 50px;
        display: flex;
        overflow: hidden;
        position: relative;
        .img{
            position: absolute;
            height: 100%;
            margin: 0 30px;
            img{
                height: 100%;
            }
        }
    }

}
</style>
